import http from 'axios'
import { push } from 'react-router-redux'
import showConfirmModal from 'features/Modal/ConfirmModal/ConfirmModal.action'

export interface IListRecordings {
  cacheKey: string
  page: number
  limit: number
  ban?: string
  serviceId?: string
}

export const listRecordings = ({ cacheKey, page, limit, serviceId, ban }: IListRecordings) => ({
  type: 'RECORDINGS/LIST_RECORDINGS',
  payload: http({
    method: 'GET',
    url: `api/v1/twilio/recordings`,
    params: {
      offset: page > 1 ? (page - 1) * limit : 0,
      limit,
      'filter[ban]': ban,
      'filter[serviceId]': serviceId,
    },
  }),
  meta: {
    cacheKey,
    page,
    limit,
  },
})

export const getRecording = (recordingId: string) => ({
  type: 'RECORDINGS/GET_RECORDING',
  payload: http({
    method: 'GET',
    url: `api/v1/twilio/recordings/${recordingId}`,
  }),
  meta: {
    recordingId,
  },
})

export const deleteRecording = (recordingId: string) => ({
  type: 'RECORDINGS/DELETE_RECORDING',
  payload: http({
    method: 'DELETE',
    url: `api/v1/twilio/recordings/${recordingId}`,
  }),
  meta: {
    recordingId,
  },
})

export const confirmDeleteRecording = (recordingId: string) => dispatch =>
  dispatch(showConfirmModal({ message: 'Are you sure?<br/>This cannot be undone.' }))
    .then(() => dispatch(deleteRecording(recordingId)))
    .then(() => dispatch(push('/dashboard/recordings')))



// WEBPACK FOOTER //
// src/features/Recordings/Recordings.actions.ts